import { Component, OnInit } from '@angular/core';
import { RouterOutlet, RouterLink, RouterLinkActive } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-debug',
  imports: [CommonModule, RouterOutlet, RouterLink, RouterLinkActive],
  template: `
    <div class="debug-container">
      <header class="debug-header">
        <h1>Debug Tools</h1>
        <nav class="debug-nav">
          <a routerLink="mocking" routerLinkActive="active">Mocking</a>
          <a routerLink="routes" routerLinkActive="active">Route Aggregator</a>
          <a routerLink="pdf-generator" routerLinkActive="active">PDF Generator</a>
          <a routerLink="single-view" routerLinkActive="active">Single View</a>
        </nav>
      </header>

      <main class="debug-content">
        <router-outlet></router-outlet>
      </main>
    </div>
  `,
  styles: [`
    .debug-container {
      padding: 20px;
      min-height: 100vh;
    }

    .debug-header {
      margin-bottom: 30px;
      border-bottom: 1px solid #ddd;
      padding-bottom: 20px;
    }

    h1 {
      color: #333;
      margin: 0 0 15px 0;
    }

    .debug-nav {
      display: flex;
      gap: 20px;
    }

    .debug-nav a {
      padding: 8px 16px;
      text-decoration: none;
      color: #666;
      border: 1px solid #ddd;
      border-radius: 4px;
      transition: all 0.2s ease;
    }

    .debug-nav a:hover {
      color: #333;
      background-color: #f8f9fa;
    }

    .debug-nav a.active {
      color: #007bff;
      border-color: #007bff;
      background-color: rgba(0, 123, 255, 0.1);
    }

    .debug-content {
      margin-top: 20px;
    }

    @media print {
      .debug-header {
        display: none !important;
      }
    }
  `]
})
export class DebugComponent implements OnInit {
  ngOnInit(): void {
    const container = document.querySelector('.outer-div') as HTMLElement
    container.style.width = '100vw'
  }
}
